const parseStatus = (status) => {
  switch (status) {
    case "PLACED":
      return "ТӨЛӨГДӨӨГҮЙ";
    case "CONFIRMED":
      return "АМЖИЛТТАЙ";
    case "CANCELLED":
      return "ЦУЦЛАГДСАН";
    case "ARCHIVED":
      return "УСТГАСАН";
    default:
      return "";
  }
};
const parsePaymentMethod = (method) => {
  switch (method) {
    case "account":
      return "Данс";
    case "card":
      return "Карт";
    case "cash":
      return "Бэлэн";
    case "qpay":
      return "Qpay";
    default:
      return "";
  }
};

const parseDeliveryStatus = (status) => {
  switch (status) {
    case "PLACED":
      return "САГС";
    case "CONFIRMED":
      return "ЗАХИАЛАГДСАН";
    case "DELIVERED":
      return "ХҮРГЭСЭН";
    case "CANCELLED":
      return "ЦУЦЛАГДСАН";
    case "ARCHIVED":
      return "УСТГАСАН";
    default:
      return "";
  }
};

const formatDateTime = (date) => {
  let month = date.getMonth() + 1;
  let day = date.getDate();
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let seconds = date.getSeconds();
  month = month < 10 ? "0" + month : month;
  day = day < 10 ? "0" + day : day;
  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;
  var strTime = hours + ":" + minutes + ":" + seconds;
  return date.getFullYear() + "-" + month + "-" + day + "  " + strTime;
};

function formatDate(d) {
  let month = "" + (d.getMonth() + 1);
  let day = "" + d.getDate();
  let year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

const formatMongolianName = (parentName, ownName) => {
  let result = "";
  if (parentName && parentName.length > 1) {
    if (ownName) {
      result += parentName.substring(0, 1);
    } else {
      result += parentName;
    }
  }
  if (ownName) {
    result += ". ";
    result += ownName;
  }
  return result;
};

const validateEmail = (email) => {
  if (!email) return false;
  var re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

const validatePhone = (phone) => {
  if (!phone) return false;
  var re =
    /^(\+{0,})(\d{0,})([(]{1}\d{1,3}[)]{0,}){0,}(\s?\d+|\+\d{2,3}\s{1}\d+|\d+){1}[\s|-]?\d+([\s|-]?\d+){1,2}(\s){0,}$/;
  return re.test(String(phone).toLowerCase());
};

const isEmpty = (value) => {
  if (value === undefined || value === null || value === "") {
    return true;
  } else {
    return false;
  }
};

const isNotEmpty = (value) => {
  if (value === undefined || value === null || value === "") {
    return false;
  } else {
    return true;
  }
};

const validatePassword = (password) => {
  if (password.length >= 8) {
    return true;
  }

  // Check for at least one capital letter (English A-Z or Mongolian А-Я/Ё/Ө/Ү)
  const hasUpperCase = /[A-ZА-ЯЁӨҮ]/g.test(password);
  if (!hasUpperCase) {
    return false;
  }

  // Check for at least one number
  const hasNumber = /[0-9]/.test(password);
  if (!hasNumber) {
    return false;
  }

  return true;
};

/**
 * Price priority: sale price → club price (club members only) → regular price
 */
const getEffectivePrice = (product, isClubMember) => {
  if (product.saleActive && product.salePrice > 0) return product.salePrice;
  if (isClubMember && product.clubPrice > 0) return product.clubPrice;
  return product.price;
};

/**
 * Turn a stored S3 key (e.g. "product/foo-sm-2024.jpg") into a full URL.
 * Passes already-absolute URLs through unchanged; falls back to the raw key
 * when env vars are missing so dev/test never break silently.
 */
const toS3Url = (key) => {
  if (!key) return "";
  if (/^https?:\/\//i.test(key)) return key;
  const bucket = process.env.REACT_APP_S3_BUCKET;
  const region = process.env.REACT_APP_S3_REGION;
  if (!bucket || !region) return key;
  return `https://${bucket}.s3.${region}.amazonaws.com/${key}`;
};

// Weight-based delivery pricing (mirror of chef-api/deliveryPricing.js).
// грамм/мл -> size/1000, кг/литр -> size, other units (ширхэг/custom) -> weightKg.
const WEIGHT_DERIVED_UNITS = ['грамм', 'мл', 'кг', 'литр'];

function needsManualWeightKg(unit) {
  if (!unit) return false;
  return WEIGHT_DERIVED_UNITS.indexOf(unit) === -1;
}

function effectiveWeightKg(product) {
  if (!product) return 0;
  const size = Number(product.size) || 0;
  switch (product.unit) {
    case 'грамм':
    case 'мл':
      return size / 1000;
    case 'кг':
    case 'литр':
      return size;
    default:
      return Number(product.weightKg) || 0;
  }
}

// cost = round(effectiveWeightKg * count / baseWeight * pricePerBase)
function computeDeliveryCost(product, count, settings) {
  const baseWeight = Number(settings && settings.deliveryBaseWeightKg) || 0;
  const basePrice = Number(settings && settings.deliveryPricePerBase) || 0;
  if (baseWeight <= 0 || basePrice <= 0) return 0;
  const totalWeight = effectiveWeightKg(product) * (Number(count) || 0);
  if (totalWeight <= 0) return 0;
  return Math.round((totalWeight / baseWeight) * basePrice);
}

export {
  parseStatus,
  getEffectivePrice,
  parseDeliveryStatus,
  formatDateTime,
  formatDate,
  formatMongolianName,
  validatePassword,
  validateEmail,
  validatePhone,
  isEmpty,
  isNotEmpty,
  parsePaymentMethod,
  toS3Url,
  needsManualWeightKg,
  effectiveWeightKg,
  computeDeliveryCost,
};
